
import moment from "moment";
import config from "@/app.config.json";

export const getToken = () => {
  const x = localStorage.getItem("user");

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken)
      return `Bearer  ${user.accessToken}`;
  }

  return "";
}

export const getUser = () => {

  let user = localStorage.getItem("user");

  if (user != null) {
    user = JSON.parse(user);
    return user;
  }

  return null;
}

export const setaFocus = (elementId: string) => {
  const el = document.getElementById(elementId);
  if (el) {
    el.focus();
  }
}

export const fdata = (dateString: string | null | undefined | Date) => {
  try {

    if (dateString == undefined || dateString == null || dateString == "") return null;

    const dateParts = dateString.toString().split("/");

    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      dateString = `${year}-${month}-${day}`;
    }

    const value = moment.utc(new Date(dateString));

    if (value.isValid())
      return moment(dateString).format("DD/MM/YYYY");
    else
      return dateString;
  } catch (error) {
    console.log("Falha em fdata '" + dateString + "' > " + error);
    return dateString;
  }
};


/**
 * Converte string no formato DD/MM/YYYY para objeto Date, evitando problemas de fuso horário
 * @param dateString - String no formato DD/MM/YYYY
 * @returns Date object ou null se inválida
 */
export const stringParaData = (dateString: string | null | undefined): Date | null => {
  try {
    if (!dateString || dateString.trim() === "") return null;

    // Remove espaços extras
    const cleanString = dateString.trim();
    
    // Verifica se está no formato DD/MM/YYYY
    const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const match = cleanString.match(regex);
    
    if (!match) return null;
    
    const dia = parseInt(match[1], 10);
    const mes = parseInt(match[2], 10);
    const ano = parseInt(match[3], 10);
    
    // Valida os valores
    if (mes < 1 || mes > 12) return null;
    if (dia < 1 || dia > 31) return null;
    
    // Cria a data explicitamente no fuso local (evita problemas UTC)
    // Usa mês-1 porque Date() usa 0-based para meses
    const data = new Date(ano, mes - 1, dia);
    
    // Verifica se a data é válida (ex: 31/02 seria inválida)
    if (data.getFullYear() !== ano || 
        data.getMonth() !== mes - 1 || 
        data.getDate() !== dia) {
      return null;
    }
    
    return data;
    
  } catch (error) {
    console.error("Erro ao converter string para data:", error);
    return null;
  }
};

/**
 * Converte string no formato DD/MM/YYYY para string no formato YYYY-MM-DD
 * @param dateString - String no formato DD/MM/YYYY  
 * @returns String no formato YYYY-MM-DD ou null se inválida
 */
export const stringParaDataISO = (dateString: string | null | undefined): string | null => {
  const data = stringParaData(dateString);
  if (!data) return null;
  
  return data.getFullYear() + '-' + 
         String(data.getMonth() + 1).padStart(2, '0') + '-' + 
         String(data.getDate()).padStart(2, '0');
};

/**
 * Converte string no formato YYYY-MM-DD para string no formato DD/MM/YYYY
 * @param isoString - String no formato YYYY-MM-DD
 * @returns String no formato DD/MM/YYYY ou null se inválida
 */
export const isoParaString = (isoString: string | null | undefined): string | null => {
  try {
    if (!isoString || isoString.trim() === "") return null;

    // Remove espaços extras
    const cleanString = isoString.trim();
    
    // Verifica se está no formato YYYY-MM-DD
    const regex = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    const match = cleanString.match(regex);
    
    if (!match) return null;
    
    const ano = parseInt(match[1], 10);
    const mes = parseInt(match[2], 10);
    const dia = parseInt(match[3], 10);
    
    // Valida os valores
    if (mes < 1 || mes > 12) return null;
    if (dia < 1 || dia > 31) return null;
    
    // Cria a data para validar se é uma data real
    const data = new Date(ano, mes - 1, dia);
    
    // Verifica se a data é válida (ex: 2026-02-31 seria inválida)
    if (data.getFullYear() !== ano || 
        data.getMonth() !== mes - 1 || 
        data.getDate() !== dia) {
      return null;
    }
    
    // Retorna no formato DD/MM/YYYY
    return String(dia).padStart(2, '0') + '/' + 
           String(mes).padStart(2, '0') + '/' + 
           String(ano);
    
  } catch (error) {
    console.error("Erro ao converter ISO para string brasileira:", error);
    return null;
  }
};

/**
 * Converte string no formato YYYY-MM-DD para objeto Date, evitando problemas de fuso horário
 * @param isoString - String no formato YYYY-MM-DD
 * @returns Date object ou null se inválida
 */
export const isoParaData = (isoString: string | null | undefined): Date | null => {
  try {
    if (!isoString || isoString.trim() === "") return null;

    // Remove espaços extras
    const cleanString = isoString.trim();
    
    // Verifica se está no formato YYYY-MM-DD
    const regex = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    const match = cleanString.match(regex);
    
    if (!match) return null;
    
    const ano = parseInt(match[1], 10);
    const mes = parseInt(match[2], 10);
    const dia = parseInt(match[3], 10);
    
    // Valida os valores
    if (mes < 1 || mes > 12) return null;
    if (dia < 1 || dia > 31) return null;
    
    // Cria a data explicitamente no fuso local (evita problemas UTC)
    // Usa mês-1 porque Date() usa 0-based para meses
    const data = new Date(ano, mes - 1, dia);
    
    // Verifica se a data é válida (ex: 2026-02-31 seria inválida)
    if (data.getFullYear() !== ano || 
        data.getMonth() !== mes - 1 || 
        data.getDate() !== dia) {
      return null;
    }
    
    return data;
    
  } catch (error) {
    console.error("Erro ao converter ISO para data:", error);
    return null;
  }
};

export const fDiaMes = (dateString: string) => {
  try {
    if (dateString == null) return null;
    const value = moment.utc(new Date(dateString));
    return moment(dateString).format("DD/MM");
  } catch (error) {
    console.log("Falha em fdata '" + dateString + "' > " + error);
    return "";
  }
};

export const fMesAno = (data: Date) => {
  let r = moment(data).format("MM/YY");

  if (r == "Invalid date") r = "";

  return r;
};

export const fdataUSS = (dateString: string | null | Date) => {
  try {

    if (dateString == undefined || dateString == null)
      return "";

    const dateParts = dateString.toString().split("/");

    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      return `${year}-${month}-${day}`;
    } else {
      const value = moment.utc(new Date(dateString));
      if (value.isValid() == false)
        return null;
      else
        return value;
    }
  }
  catch (error) {

    return null;
  }
};

export const fdataUS = (data: Date | any) => {
  try {
    if (data == null || data == "") return null;

    data = fStrToDateUS(data);

    const dataBr = moment.utc(data);
    if (dataBr.isValid())
      return moment(dataBr).format("YYYY-MM-DD");
    else
      return data;
  } catch (error) {
    console.log("Falha em fdataUS '" + data + "' > " + error);
    return null;
  }
};

export const fdataHora = (dateString: string| null | undefined | Date) => {
  try {
    if (dateString == undefined || dateString == null || dateString == "") return null;
    const value = moment.utc(new Date(dateString));
    if (value.isValid())
      return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
    else
      return dateString;
  } catch (error) {
    console.log("Falha em fdata '" + dateString + "' > " + error);
    return dateString;
  }
};

export const fdataHoraUS = (data: Date | any) => {
  try {
    if (data == null || data == "") return null;

    // eslint-disable-next-line no-var
    var data = fStrToDateUS(data);

    const dataBr = moment.utc(data);

    if (dataBr.isValid())
      return moment(dataBr).format("YYYY-MM-DDTHH:mm:ss");
    else
      return data;
  } catch (error) {
    console.log("Falha em fdataUS '" + data + "' > " + error);
    return null;
  }
};

export const fStrToDateUS = (data: string | any) => {

  let dataBr = moment.utc(data);
  if (dataBr.isValid())
    return dataBr;

  let sep = "/";

  if (data.indexOf("-") > 0)
    sep = "-";

  const dia = data.toString().split(sep)[0];
  const mes = data.toString().split(sep)[1];
  const ano = data.toString().split(sep)[2];
  data = `${ano}-${mes}-${dia}`;
  dataBr = moment.utc(data);
  if (dataBr.isValid())
    return dataBr;

  return data;

}

export const fhora = (dateString: string) => {
  const value = new Date(dateString);
  return moment(value).format("HH:mm:ss");
};

export const fMilhao = (entrada: any) => {
  const value = entrada ? Number(entrada) : 0;
  return value.toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

export const f2dec = (entrada: any, maximoDigito = 2) => {
  const value = entrada ? Number(entrada) : 0;
  return value.toLocaleString("pt-BR", { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: maximoDigito });
};

export const f3dec = (entrada: any, maximoDigito = 3) => {
  const value = entrada ? Number(entrada) : 0;
  return value.toLocaleString("pt-BR", { useGrouping: true, minimumFractionDigits: 3, maximumFractionDigits: maximoDigito });
};


export const f4dec = (entrada: any, maximoDigito = 4) => {
  const value = entrada ? Number(entrada) : 0;
  return value.toLocaleString("pt-BR", { useGrouping: true, minimumFractionDigits: 4, maximumFractionDigits: maximoDigito });
};

export const f5dec = (entrada: any, maximoDigito = 5) => {
  const value = entrada ? Number(entrada) : 0;
  return value.toLocaleString("pt-BR", { useGrouping: true, minimumFractionDigits: 5, maximumFractionDigits: maximoDigito });
};

export const fCortar = (texto: string, qtdeCaracteres: number, reticencias?: any) => {
  if (texto != null && texto.length > qtdeCaracteres) {
    texto = texto.substring(0, qtdeCaracteres);
    if (reticencias == undefined || reticencias == true)
      texto += "...";
  }

  return texto;
};

export function SimboloMoeda() {
  return (0)
    .toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}

export function SimNao(valor?: boolean) {
  return valor == true ? "SIM" : "NAO";
}

export const round = (entrada: any, maximoDigito = 2) => {
  const value = entrada ? parseFloat(entrada.toFixed(maximoDigito)) : 0;
  return value;
};

export const primeiroDiaMes = () => {
  const date = new Date();
  const ano = date.getFullYear();
  const mes = date.getMonth();
  const r = new Date(ano, mes, 1);
  return moment(r).format("YYYY-MM-DD");
};

export const ultimoDiaMes = () => {
  const date = new Date();
  const ano = date.getFullYear();
  const mes = date.getMonth();
  const r = new Date(ano, mes + 1, 0);
  return moment(r).format("YYYY-MM-DD");
};

export const fDifData = (dataMaior: Date, dataMenor: Date) => {
  const date1 = new Date(dataMenor).getTime();
  const date2 = new Date(dataMaior).getTime();
  const diffDays = (date2 - date1) / (1000 * 60 * 60 * 24);
  return Math.trunc(diffDays);
};

export const fDifMinutos = (dataMaior: Date, dataMenor: Date) => {
  const date1 = new Date(dataMenor).getTime();
  const date2 = new Date(dataMaior).getTime();
  const dif = (date2 - date1) / (1000 * 60);
  return dif;
};

export function addDays(date: Date, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const imprimir = (nomeElemento: string) => {
  if (nomeElemento != undefined) {
    const printableContent = document.getElementById(nomeElemento);
    const printWindow = window.open("", "", "height=1000,width=1000");
    if (printWindow != null && printableContent != null) {
      printWindow.document.write(printableContent.innerHTML);
      printWindow.print();
    }
  } else window.print();
};

export function isNumber(val: string | undefined | null | any) {
  if (val == undefined || val == null || val == "") return false;

  return !isNaN(parseFloat(val));
}

export function curBr(num: any, decimais?: any) {
  //descricao: converte um texto de americano para portugues
  //           trocando o ponto pela virgula
  //exemplo: 0.00 > 0,00
  //utilizacao: ao colocar o valor numa caixa de texto

  num = isNaN(num) || num === "" || num === null ? 0.0 : num;
  if (decimais == null || decimais == "undefined") decimais = 2;
  const aux = parseFloat(num).toFixed(decimais).toString();
  return aux.replace(".", ",");
}

export function verificaNumero(str: string): boolean {

  // Remove espaços em branco da string (se necessário)
  str = str.toString().replace(/\s/g, "");

  // Verifica se a string contém apenas dígitos
  return /^\d+$/.test(str);
}

export function curUs(num: any, decimais?: any) {
  //descricao: converte um texto de portugues para americado
  //           trocando a virgula pelo ponto, utilizado para capturar
  //           os valores dos campos antes de fazer calculos
  //exemplo: 0,00 > 0.00
  //utilizacao: para capturar
  //           os valores dos campos antes de fazer calculos

  if (num == undefined || num == "") return 0.0;

  if (decimais == null || decimais == "undefined") decimais = 2;

  if (num.toString().includes(",")) num = parseFloat(parseFloat(num.replaceAll(".", "").replace(",", ".")).toFixed(decimais));
  else num = parseFloat(parseFloat(num).toFixed(decimais));

  return num;
}

export function ordenarTabela(tabela: [], coluna: string, ordem: "asc") {
  if (ordem == undefined || ordem == "asc")
    tabela = tabela.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
  else
    tabela = tabela.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
  return tabela;
}

export function usuarioLogado(): ILoginResultDTO | null {
  const x = localStorage.getItem("user");

  if (x != null) {
    const user = JSON.parse(x);

    if (user) {
      return user;
    } else {
      return null;
    }
  } else return null;
}

export interface ILoginResultDTO {
  userName: string;
  role: string;
  accessToken: string;
  refreshToken: string;
  usuarioId: number;
  nomeUsuario: string;
}

export function salvarFiltros(titulo: string, objetoFiltros: object) {
  localStorage.setItem(titulo, JSON.stringify(objetoFiltros));
}

export function carregarFiltros(titulo: string): object | null {
  const filtros = localStorage.getItem(titulo);
  if (filtros != null) return JSON.parse(filtros);
  else return null;
}


export function isDate(data: any) {
  return data instanceof Date && !isNaN(data.valueOf());
}

// Alguns contratos antigos têm no texto <img src='/Param/...'> — um caminho relativo que só existe
// na API, não no front que está exibindo o HTML. Sem isso o navegador tenta buscar a imagem na
// própria origem do front (ex: localhost:8080/Param/...) e ela nunca aparece.
export function corrigirImagensContrato(html: string | null | undefined): string {
  if (!html) return "";
  return html.replace(/src=(['"])\/(?!\/)/g, `src=$1${config.urlApi}/`);
}
